"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const react_dom_1 = __importDefault(require("react-dom"));
const react_1 = __importDefault(require("react"));
const frontend_library_darkhorse_1 = require("@usafacts/frontend-library-darkhorse");
const legacyMetricsConverter_1 = require("@usafacts/frontend-library-darkhorse/src/utilities/legacyMetricsConverter");
class LineChartReact {
  constructor(container) {
    this.container = container;
  }
  async draw(promises, options) {
    const data = (await promises.data) || [];
    react_dom_1.default.render(react_1.default.createElement(frontend_library_darkhorse_1.LineChart, {
      ...options,
      data: data.map(legacyMetricsConverter_1.middlewareDataToChartData)
    }), this.container.node());
  }
}
exports.default = LineChartReact;